import { useState, useEffect } from 'react';
import { Header } from '../components/Header';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';
import { usePageActions } from '../contexts/PageActionsContext';

// Schema e form removidos - configurações de IA centralizadas

export function SettingsPage() {
  const [loading, setLoading] = useState(true);
  // Modais de IA removidos - configurações centralizadas
  const { user, isUrlLogin } = useAuth();
  const { theme } = useTheme();
  const { registerMetadata } = usePageActions();


  // Form hooks removidos - configurações de IA centralizadas

  useEffect(() => {
    // Configurações de IA centralizadas no SUPERADMIN — nada para carregar por tenant
    setLoading(false);
  }, [user]);

  // 🎯 Register metadata for iframe mode
  useEffect(() => {
    if (isUrlLogin) {
      registerMetadata('/configuracoes', {
        title: 'Configurações',
        subtitle: 'Configure as definições do sistema'
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUrlLogin]);


  if (loading) {
    return (
      <div className="p-6">
        <div className="flex items-center justify-center h-64">
          <div style={{ color: 'var(--text-secondary)' }}>Carregando configurações...</div>
        </div>
      </div>
    );
  }

  return (
    <>
      {/* Header - Only show in normal mode */}
      {!isUrlLogin && (
      <Header
        title="Configurações"
        subtitle="Configure as definições do sistema"
      />
      )}

      <div className="p-6">
        <div className="max-w-4xl mx-auto">
          <div 
            className="rounded-lg shadow p-6"
            style={{
              backgroundColor: 'var(--bg-card)',
              color: 'var(--text-primary)',
              border: '1px solid var(--border-color)'
            }}
          >
            <h2 
              className="text-lg font-semibold mb-6"
              style={{ color: 'var(--text-primary)' }}
            >
              🤖 Integrações de IA
            </h2>
            <p 
              className="mb-6"
              style={{ color: 'var(--text-secondary)' }}
            >
              As configurações de IA são gerenciadas centralmente pelo SUPERADMIN
            </p>

            <div 
              className="rounded-lg p-6"
              style={{
                backgroundColor: theme === 'dark' ? '#1e3a5f' : '#eff6ff',
                border: `1px solid ${theme === 'dark' ? '#2d4a6b' : '#bfdbfe'}`,
              }}
            >
              <div className="flex items-start">
                <div className="flex-shrink-0">
                  <div 
                    className="text-xl"
                    style={{ color: theme === 'dark' ? '#60a5fa' : '#60a5fa' }}
                  >
                    ℹ️
                  </div>
                </div>
                <div className="ml-3">
                  <h3 
                    className="text-sm font-medium"
                    style={{ color: theme === 'dark' ? '#bfdbfe' : '#1e40af' }}
                  >
                    Configurações Centralizadas
                  </h3>
                  <div 
                    className="mt-2 text-sm"
                    style={{ color: theme === 'dark' ? '#93c5fd' : '#1e3a8a' }}
                  >
                    <p>
                      As API Keys de IA (OpenAI e Groq) são configuradas globalmente pelo SUPERADMIN 
                      e compartilhadas por todos os tenants. Isso garante que todos os usuários 
                      tenham acesso às funcionalidades de IA sem necessidade de configuração individual.
                    </p>
                    <p className="mt-2">
                      <strong>Funcionalidades disponíveis:</strong>
                    </p>
                    <ul className="mt-1 list-disc list-inside">
                      <li>Geração de mensagens com OpenAI GPT</li>
                      <li>Geração de mensagens com Groq LLaMA</li>
                      <li>Substituição automática de variáveis</li>
                      <li>Configuração de prompts personalizados</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modais de IA removidos - configurações centralizadas no SUPERADMIN */}
    </>
  );
}